module.exports = __webpack_public_path__ + "static/media/circuit2.1e3707a2.gif";